quoteModule.factory('dealProductService', ['$http','AppSettings', 'commonRESTCallService', 'erateSessionVarsService',
    'imSessionVarsService','$q','rateQuoteRetrievalCoordService','rateQuoteCoordService',
function ($http, appSettings, commonRESTCallService, erateSessionVarsService,
    imSessionVarsService,$q,rateQuoteRetrievalCoordService,rateQuoteCoordService) {
    //
    var dealProductService = {};

    dealProductService.prodsDependentOnFianceInfo = null;

    //COM-811:
    dealProductService.inCleanQueueProcess = false;
    dealProductService.getInCleanQueueProcess = function() {
        return dealProductService.inCleanQueueProcess;
    }

    dealProductService.setInCleanQueueProcess = function(inProcess) {
        dealProductService.inCleanQueueProcess = inProcess;
    }

    //COM-808
    //retrieve what products "re rate" when deal information changes (by provider)
    //
    dealProductService.getProductsReRateOnDealChange = function() {
        var deferred = $q.defer();

        if (!dealProductService.prodsDependentOnFianceInfo){
            //call the service
            var url = appSettings.startSPANVehicleProductSvcURL + "/RetrieveProductTypesDependOnFinanceInfo/" +
                imSessionVarsService.getCurrentProviderCode();
            commonRESTCallService.getFromServer(url)
            .success(function(data, status) {
                dealProductService.prodsDependentOnFianceInfo = data;
                deferred.resolve(data);
            })
            .error(function(data, status) {
                deferred.reject(status + ' ' + data);
            });
        }else{
            deferred.resolve(dealProductService.prodsDependentOnFianceInfo);
        }
        return deferred.promise;
    }
    return dealProductService;

}]);
